import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Select, Store } from '@ngxs/store';
import { NGXLogger } from 'ngx-logger';
import { Observable, Subscription } from 'rxjs';
import { EmployeesAddModalComponent } from 'src/app/employees/employees-add-modal/employees-add-modal.component';
import { FetchEmployees } from 'src/app/employees/employees.actions';
import { EmployeeState } from 'src/app/employees/employees.state';
import { Employee } from 'src/app/models/Employee';
import Project from 'src/app/models/Project';

import { AddProjectEmployee, DeleteEmployeeFromProjectById, FetchProjects } from '../project.actions';
import { ProjectState } from '../project.state';
import { EmployeeLinkModalComponent } from './employee-link-modal/employee-link-modal.component';

@Component({
    selector: 'app-employee-link',
    templateUrl: './employee-link.component.html',
    styleUrls: ['./employee-link.component.scss'],
})
export class EmployeeLinkComponent implements OnInit, OnDestroy {
    private subscriptions = new Subscription();

    @Select(ProjectState.projects) works$: Observable<Project[]>;
    @Select(EmployeeState.Employees) employees$: Observable<Employee[]>;

    @Input() work: Project;

    linkedEmployees: Employee[] = [];
    data: Employee[] = [];
    isLoading = true;
    removingLink = false;
    selectedItem: Employee;
    pricePerHour: number;

    constructor(private logger: NGXLogger, private store: Store, private modalService: NgbModal) {}

    ngOnInit(): void {
        const employeesTemp: Employee[] = [];
        this.work.linkedEmployees && this.work.linkedEmployees.forEach((e) => employeesTemp.push(e.employee));
        this.linkedEmployees = JSON.parse(JSON.stringify(employeesTemp));
        this.subscriptions.add(
            this.employees$.subscribe((employees) => {
                if (employees == null) {
                    this.store.dispatch(new FetchEmployees());
                } else {
                    this.data = employees.filter((emp) => !this.linkedEmployees.find((e) => e.uuid == emp.uuid));
                    this.isLoading = false;
                }
            }),
        );
    }

    createItemFunction = (args: any): void => {
        this.logger.debug('opening addEmployeeModal');
        const modalRef = this.modalService.open(EmployeesAddModalComponent, {
            windowClass: 'modal-pane',
            animation: false,
        });
        this.subscriptions.add(
            modalRef.componentInstance.emitObject.subscribe((employee) => {
                this.selectedItem = employee;
            }),
        );
    };

    linkItemFunction = (): void => {
        if (this.selectedItem != undefined) {
            this.logger.debug('Linking work with employee');
            this.linkedEmployees.push(this.selectedItem);
            this.data = this.data.filter((e) => e.uuid != this.selectedItem.uuid);
            const employee: Employee = JSON.parse(JSON.stringify(this.selectedItem));
            const pricePerHour = this.pricePerHour != undefined ? this.pricePerHour : 0;
            this.subscriptions.add(
                this.store.dispatch(new AddProjectEmployee(this.work.uuid, employee, pricePerHour)).subscribe(() => {
                    this.store.dispatch(new FetchProjects());
                    this.store.dispatch(new FetchEmployees());
                }),
            );
            this.selectedItem = undefined;
        }
    };

    unlinkItemById(id: string): void {
        this.removingLink = true;
        this.subscriptions.add(
            this.store.dispatch(new DeleteEmployeeFromProjectById(id)).subscribe(() => {
                this.store.dispatch(new FetchProjects()).subscribe(() => {
                    const employees: Employee[] = [];
                    this.work.linkedEmployees.forEach((e) => employees.push(e.employee));
                    this.linkedEmployees = JSON.parse(JSON.stringify(employees));
                    this.removingLink = false;
                });
                this.store.dispatch(new FetchEmployees());
            }),
        );
    }

    openSelectModal() {
        const modalRef = this.modalService.open(EmployeeLinkModalComponent, {
            windowClass: 'modal-prompt',
        });
        modalRef.componentInstance.data = this.data;
        modalRef.componentInstance.isLoading = this.isLoading;
        modalRef.componentInstance.addItemFunction = this.createItemFunction;
        this.subscriptions.add(
            modalRef.componentInstance.emitObject.subscribe((emitObject) => {
                this.selectedItem = emitObject.employee;
                this.pricePerHour = emitObject.price;
                this.linkItemFunction();
            }),
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
